module.exports = __webpack_public_path__ + "img/DSC_2770-xs.63467c69.png";